export default __webpack_public_path__ + "img/filter_CB.3ab3e248af61ded4c2bc82b2be291bd6.jpg";